import React from "react";
import { ClimbingArea, ForecastDataPoint } from "../types";
import { ForecastSymbolImage, SymbolSize, 
  formatTemperature,
  timeToHour, 
  timeToDow,
  timeToDowLocale,
  symbolHasPrecip} from "./climbingAreaForecast";

/// Hourly area
interface HourlyProps { area: ClimbingArea }
const Hourly = (props: HourlyProps) => {
    const area = props.area;
    return (
        <div id="hourlies">
            { area.forecast?.hourly.data.map( (forecast, i) => (
                <div className="hourlyCell" key={forecast.time}>
                    <div className="hourly__dow">{i === 0 || timeToDowLocale(forecast.time, area.forecast!.timezone) !== timeToDowLocale(area.forecast!.hourly.data[i-1].time, area.forecast!.timezone) ? timeToDowLocale(forecast.time, area.forecast!.timezone) : ""}</div>
                    <div className="hourlyTime">{timeToHour(forecast.time, area.forecast!.timezone)}</div>
                    <div className="hourlySymbol"><ForecastSymbolImage icon={forecast.icon} size={SymbolSize.Small} testId={String(forecast.time)} /></div>
                    <div className="hourlyTemp">{formatTemperature(forecast.temperature)}</div>
                    <PrecipBySymbol precip={forecast.precipProbability} />
                    {/*
                    <div className="hourly__accum">{formatPrecipAccum(forecast.precipAccumulation, symbolHasPrecip(forecast.icon))}</div>
                    <div className="hourly__wind">{formatWind(forecast.windSpeed)}</div>
            */}
                </div>
            ))}
        </div>
    );
    
};

interface PrecipBySymbolProps { 
    precip: string | undefined
}
function PrecipBySymbol(props: PrecipBySymbolProps) {
    const { precip } = props;
    if (precip === undefined) {
        return null;
    }
    const precipPercentage = Math.round(parseFloat(precip)*100)
    return (
        <div className="hourlyPrecip">{precipPercentage.toString() + "%"}</div>
    );
}

const formatPrecipAccum = (precip: string | undefined, hasPrecip: boolean): string | null => {

    if (precip === undefined || !hasPrecip) {
        return null;
    }

    return precip;

}

const formatWind = (windSpeed: string | undefined): string | null => {
    if (windSpeed === undefined) {
        return null;
    }

    return windSpeed + " mph"
}

export default Hourly;